import React, { useEffect, useState } from 'react';
import { useTheme } from '../abstracts/theme';
import { ThemeProvider, StyleSheetManager } from 'styled-components';
function createLowPriorityStylesheet() {
    var stylesheet = document.createElement('style');
    stylesheet.setAttribute('data-asurion-ui-stylesheet', 'true');
    stylesheet.setAttribute('type', 'text/css');
    var head = document.getElementsByTagName('head')[0];
    head.insertBefore(stylesheet, head.childNodes[0]);
    return stylesheet;
}
/**
 * Provides internal stuff we need for our components.
 * Injects Styled Components theme prop via context.
 */
export var InternalProvider = function (_a) {
    var children = _a.children;
    var _b = useState(), targetStylesheet = _b[0], setTargetStylesheet = _b[1];
    var theme = useTheme();
    useEffect(function () {
        if (!targetStylesheet && typeof window !== 'undefined') {
            setTargetStylesheet(createLowPriorityStylesheet());
        }
    }, []);
    return (React.createElement(StyleSheetManager, { target: targetStylesheet },
        React.createElement(ThemeProvider, { theme: theme }, children)));
};
